export const ERROR_REASON_LABELS: Record<string, string> = {
  missing_required_field: '入力データに必須情報（数量、納期、発注番号など）が存在しません。',
  agg_biz_not_exist: '取引が存在しません。取引情報をマスターに登録してください。',
  duplicate_request_order: 'ファイル内で発注が重複しています。数量をまとめるか発注番号を分けて登録してください。',
  duplicate_request_order_issued_number: 'ファイル内で発注管理番号が重複しています。',
  multiple_matching: '対象の発注が複数存在します。',
  order_not_found: '対象の発注が存在しません。',
  belong_to_order_group: '更新対象の発注が発注グループに紐づいているため更新できませんでした。',
  already_registered_order_number: '対象の発注には既に発注番号が付与されています。',
  already_registered_order: '対象の発注が既に存在します。',
  unknown: '未知のエラーが発生しました。',
};

export const TABLE_HEADERS = [
  { key: 'checkbox', label: '', width: '48px', type: 'uni' },
  { key: 'warehouseNumber', label: '置場CD', width: '100px', type: 'str' },
  { key: 'warehouse', label: '置場名', width: '120px', type: 'str' },
  { key: 'supplierNumber', label: '仕入先CD', width: '100px', type: 'str' },
  { key: 'supplierName', label: '仕入先名', width: '180px', type: 'str' },
  { key: 'businessNumber', label: '商品CD', width: '100px', type: 'str' },
  { key: 'businessName', label: '商品名', width: '160px', type: 'str' },
  { key: 'package', label: '容量', width: '80px', type: 'num' },
  { key: 'orderNumber', label: '発注番号', width: '140px', type: 'str' },
  { key: 'orderIssuedNumber', label: '発注管理番号', width: '140px', type: 'str' },
  { key: 'createdOrderDate', label: '発注作成日', width: '120px', type: 'date' },
  { key: 'desiredDeliveryDate', label: '希望納期', width: '120px', type: 'date' },
  { key: 'estimatedTimeOfArrival', label: '納期', width: '120px', type: 'date' },
  { key: 'orderAmount', label: '数量', width: '80px', type: 'num' },
  { key: 'orderStatus', label: 'ステータス', width: '120px', type: 'uni' },
  { key: 'errorReason', label: 'エラー理由', width: '500px', type: 'uni' },
  { key: 'headerModify', label: 'ヘッダー編集', width: '60px', type: 'uni' },
];
